import {
  LOGOUT_REQUEST,
  LOGOUT_SUCCESS,
  LOGOUT_FAILURE,
  LOGOUT_RESET
} from "../../actionTypes";

const initialState = {
  status: false,
  isLoading: false,
  message: "",
  data: {},
};

const logoutReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOGOUT_REQUEST:
      // console.log(action.payload);
      return {
        ...state,
        isLoading: true,
      };
    case LOGOUT_SUCCESS:
      return {
        ...state,
        status: action.payload.status,
        isLoading: false,
        message: action.payload.message,
        data: action.payload.data,
      };
    case LOGOUT_FAILURE:
      return {
        ...state,
        status: action.payload.status,
        isLoading: false,
        message: action.payload.message,
      };

    case LOGOUT_RESET: // Reset job data
      return {
        ...state,
        status: false,
        isLoading: false,
        message: "",
      };
    default:
      return state;
  }
};

export default logoutReducer;
